import { createEvent } from 'effector';
import { type DeclineOrderProps } from './DeclineOrder';
import { openDeclineOrderModal } from './lib';

export const declineOrder = createEvent<DeclineOrderProps>();

declineOrder.watch(openDeclineOrderModal);
